export default function QuePrefiere(){
    return(
        <h1>Que prefiere?</h1>
        )
}